{
  "version": 1,
  "asset_id": "b1438d89-8b98-4202-bf7f-3b2b58c0f675",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/b1438d89-8b98-4202-bf7f-3b2b58c0f675/thumb-butoh.webp",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/b1438d89-8b98-4202-bf7f-3b2b58c0f675/thumb-butoh.webp",
  "original_filename": "thumb-butoh.webp",
  "size": 29178,
  "content_type": "image/webp",
  "created_at": "2026-10-28T12:00:27Z"
}
